import script from "./AIPromptFavoriteList.vue?vue&type=script&setup=true&lang=js"
export * from "./AIPromptFavoriteList.vue?vue&type=script&setup=true&lang=js"

import "./AIPromptFavoriteList.vue?vue&type=style&index=0&id=1321f00c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1321f00c"]])

export default __exports__